/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import FilterButton from '@components/navbar/FilterButton';
import MoreButton from '@components/navbar/MoreButton';

import SalesActivityScreen from '@/screens/sales-activity/SalesActivityScreen';
import SalesActivityListScreen from '@/screens/sales-activity/SalesActivityListScreen';

import { showPopup } from '@/store/modal';

const Stack = createStackNavigator();

const SalesActivityNavigator = ({ navigation }) => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const isShowFilter = useSelector((state) => state.modal.showFilter);

  return (
    <Stack.Navigator
      initialRouteName="SalesActivityScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="SalesActivityScreen"
        component={SalesActivityScreen}
        options={(props) => {
          return {
            title: setTitleHeader('Sales Activity'),
          };
        }}
      />
      <Stack.Screen
        name="SalesActivityListScreen"
        component={SalesActivityListScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Sales Activity List';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          const goBack = () => {
            if (props?.route?.params?.isHome) {
              const { isHome, ...restParams } = props.route?.params || {};
              props.navigation.replace('SalesActivityListScreen', restParams);
              props.navigation.navigate('HomeNavigator');
            } else {
              props.navigation.navigate('SalesActivityScreen');
            }
          };

          const menus = [
            {
              type: 'function',
              name: 'Filter',
              callback: () =>
                dispatch(
                  showPopup({
                    name: 'showFilter',
                    value: isShowFilter ? false : 'sales-activity',
                  }),
                ),
            },
          ];

          const isShowDelete =
            !hasNoAccess(['superadmin', 'general']) &&
            ['planned_activities', 'overdue_activities'].includes(
              props?.route?.params?.type,
            );

          if (isShowDelete) {
            menus.unshift({
              type: 'function',
              name: 'Delete',
              callback: () =>
                dispatch(
                  showPopup({ name: 'showBulkDeleteActivity', value: true }),
                ),
            });
          }

          if (
            ['overdue_activities', 'past_activities'].includes(
              props?.route?.params?.type,
            )
          ) {
            menus.unshift({
              type: 'function',
              name: 'Export',
              callback: () =>
                dispatch(showPopup({ name: 'showPastExport', value: true })),
            });
          }

          if (
            ['overdue_activities', 'past_activities'].includes(
              props?.route?.params?.type,
            )
          ) {
            menus.unshift({
              type: 'function',
              name: 'Export GWP Tracker',
              callback: () =>
                dispatch(showPopup({ name: 'showGWPTracker', value: true })),
            });
          }

          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton {...props} onPress={() => goBack()} />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : props?.route?.params?.type == 'past_activities' ||
                isShowDelete ? (
                <MoreButton menu={menus} {...props} />
              ) : (
                <FilterButton name="sales-activity" {...props} />
              ),
            ...(!isWeb
              ? {
                  headerTitleStyle: {
                    color: isWeb ? 'transparent' : '#FFFFFF',
                    fontFamily: 'figtree-medium',
                    marginLeft: -20,
                    fontSize: 17,
                  },
                }
              : {}),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default SalesActivityNavigator;
